const JIRA_ISSUE_KEY_REGEX = /^https?:\/\/\S+\/browse\/(?<key>[A-Z][A-Z0-9]+-\d+)/i;

export const extractJiraIssueKey = (url) => (
  url.match(JIRA_ISSUE_KEY_REGEX)?.groups.key.toUpperCase() ?? null
);
